export default __webpack_public_path__ + "static/media/Social Links.bd03218b.svg";